"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var cashPricesLabelStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return ({
        link: {
            color: palette.primary.main,
            textDecoration: 'underline',
        },
        tooltipCloseIcon: {
            position: 'absolute',
            right: 10,
            top: 10,
            color: palette.primary.main,
            fontSize: typography.fontXL,
            cursor: 'pointer',
        },
        priceLabelText: {},
    });
}, { name: 'Summary_CashPricesTooltip' });
exports.default = cashPricesLabelStyles;
